<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M17 20C17.5523 20 18 20.4477 18 21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21C6 20.4477 6.44772 20 7 20H17ZM17 2C17.5128 2 17.9355 2.38604 17.9933 2.88338L18 3V12C18 15.3137 15.3137 18 12 18C8.7616 18 6.12243 15.4344 6.00414 12.2249L6 12V3C6 2.44772 6.44772 2 7 2C7.51284 2 7.93551 2.38604 7.99327 2.88338L8 3V12C8 14.2091 9.79086 16 12 16C14.1422 16 15.8911 14.316 15.9951 12.1996L16 12V3C16 2.44772 16.4477 2 17 2Z"
    fill="currentColor"
  />
</svg>
